/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_resolveInterestRequest } from '../models/api_resolveInterestRequest';
import type { api_resolveInterestResponse } from '../models/api_resolveInterestResponse';
import type { db_ListInterestsRow } from '../models/db_ListInterestsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Interests {
    /**
     * Get a list of interests
     * @returns db_ListInterestsRow OK
     * @throws ApiError
     */
    public static listInterests(): CancelablePromise<Array<db_ListInterestsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/interests',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Apply an alumni survey reviewer's rename/sensitivity edit to an interest
     * @param id Interest ID
     * @param body Interest edit
     * @returns api_resolveInterestResponse OK
     * @throws ApiError
     */
    public static resolveInterest(
        id: number,
        body: api_resolveInterestRequest,
    ): CancelablePromise<api_resolveInterestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/interests/{id}/resolve',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
